var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 45.145 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7348",
    "data-name": "Group 7348",
    transform: "translate(-2.25 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22671",
    "data-name": "Path 22671",
    d: "M30.674,5.594a1.672,1.672,0,0,0,0-3.344H23.885c-4.094,0-7.3,0-9.85.276A12.982,12.982,0,0,0,7.534,4.7,12.819,12.819,0,0,0,4.7,7.534a12.982,12.982,0,0,0-2.172,6.5c-.276,2.546-.276,5.756-.276,9.85v.2c0,4.094,0,7.3.276,9.85a12.983,12.983,0,0,0,2.172,6.5,12.818,12.818,0,0,0,2.836,2.836,12.982,12.982,0,0,0,6.5,2.173c2.546.276,5.756.276,9.85.276h.2c4.094,0,7.3,0,9.85-.276a12.982,12.982,0,0,0,6.5-2.173,12.816,12.816,0,0,0,2.836-2.836,12.982,12.982,0,0,0,2.173-6.5c.276-2.546.276-5.756.276-9.85V17.3a1.672,1.672,0,1,0-3.344,0v6.688c0,4.217,0,7.245-.256,9.591a9.731,9.731,0,0,1-1.553,4.9,9.471,9.471,0,0,1-2.1,2.1,9.731,9.731,0,0,1-4.9,1.553c-2.345.254-5.374.256-9.591.256s-7.245,0-9.591-.256a9.732,9.732,0,0,1-4.9-1.553,9.473,9.473,0,0,1-2.1-2.1,9.73,9.73,0,0,1-1.553-4.9c-.254-2.345-.256-5.374-.256-9.591s0-7.245.256-9.591A9.731,9.731,0,0,1,7.4,9.5,9.475,9.475,0,0,1,9.5,7.4,9.731,9.731,0,0,1,14.4,5.85c2.345-.254,5.374-.256,9.591-.256Z",
    transform: "translate(0 0.922)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22672",
    "data-name": "Path 22672",
    d: "M6.421,22.068a1.672,1.672,0,1,0,3,1.473L12.679,16.9a2.656,2.656,0,0,1,4.842.164,6,6,0,0,0,10.94.371L31.717,10.8a1.672,1.672,0,0,0-3-1.473l-3.256,6.637a2.656,2.656,0,0,1-4.842-.164,6,6,0,0,0-10.94-.371Z",
    transform: "translate(4.917 8.474)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22673",
    "data-name": "Path 22673",
    d: "M17.5,7.073A5.573,5.573,0,1,0,23.073,1.5,5.573,5.573,0,0,0,17.5,7.073Zm3.344,0a2.229,2.229,0,1,0,2.229-2.229A2.229,2.229,0,0,0,20.844,7.073Z",
    transform: "translate(18.748 0)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconDashboard);
export default __webpack_public_path__ + "static/media/TabIconDashboard.0e1deb9d601ef1c5baa1287cbcf7d292.svg";
export { ForwardRef as ReactComponent };